import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import Footer from '../../component/Footer/Footer';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import "./RolesAndUser.scss"
import { useNavigate, useLocation } from 'react-router-dom';
import RolesAndPermission from '../RolesAndPermission/RolesAndPermission';
import UserManagement from '../UserManagement/UserManagement';
import AreaExecutive from '../AreaExecutive/AreaExecutive';
import { useDispatch } from "react-redux";
import { loginRolesAction } from '../../actions/permissionAction';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { hasPermission } from '../../utils/permissionUtils';
import { PERMISSIONS } from '../../constants/permissions/Permissions';
import { safeDecode } from '../../common/decoder';

const RolesAndUser = () => {

    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const language = Cookies.get("language");
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [activeComponent, setActiveComponent] = useState('roles')
    const location = useLocation();
    const language_id = safeDecode(Cookies.get("language_id"));

    useEffect(() => {
        handleChangeLanguage(language);
        loginrolesdata();

        if (location.state && location.state.activeComponent) {
            setActiveComponent(location.state.activeComponent);
        }
    }, []);

    async function loginrolesdata() {
        setIsLoading(true);
        let response = await dispatch(loginRolesAction(language_id));
        if (response?.status == HTTP_STATUS.SUCCESS) {
            if (response) {
                setRoles(response?.data?.data);
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
            }
        }

    }

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const getNavigationName = () => {
        switch (activeComponent) {
            case 'roles':
                return `${t('RolesAndPermission.rolesAndPermission')}`;
            case 'userManagement':
                return `${t('userManagement.usermanagement')}`;
            case 'areaExecutive':
                return `${t('areaExecutive.areaexecutive')}`;;
            default:
                return `${t('RolesAndPermission.rolesAndPermission')}`;
        }
    };

    const handleCreateUser = () => {
        navigate('/create_user', { state: { roles } })
    }

    const handleCreateRole = () => {
        navigate('/create_role', { state: { roles } })
    }

    const handleAddAreaExecutive = () => {
        navigate('/add_area_executive', { state: { roles } })
    }

    return (
        <div className="role-permission-containers">
            <div className="role-permission-main">
                <div className='role-permission'>
                    <div className="header-navigation">
                        <p className="roles-permission-text">TVS &gt; {getNavigationName()}</p>
                    </div>
                    <div className='roles-users-section'>
                        <div className="page-navigation-buttons">
                            <div className='navigation-button-flex'>
                                <button
                                    className={activeComponent === 'roles' ? 'active' : ''}
                                    onClick={() => setActiveComponent('roles')}
                                >
                                    {t('RolesAndPermission.rolesAndPermission')}
                                </button>
                                {hasPermission(PERMISSIONS.CAN_VIEW_ADMIN_USERS) && (
                                    <button
                                        className={activeComponent === 'userManagement' ? 'active' : ''}
                                        onClick={() => setActiveComponent('userManagement')}
                                    >
                                        {t('userManagement.usermanagement')}
                                    </button>
                                )}
                                {hasPermission(PERMISSIONS.CAN_VIEW_AREA_EXECUTIVES) && (
                                    <button
                                        className={activeComponent === 'areaExecutive' ? 'active' : ''}
                                        onClick={() => setActiveComponent('areaExecutive')}
                                    >
                                        {t('areaExecutive.areaexecutive')}
                                    </button>
                                )}
                            </div>
                            <div className='action-button'>
                                {activeComponent === 'roles' && hasPermission(PERMISSIONS.CAN_CREATE_ROLE_AND_PERMISSION) && (
                                    <button onClick={handleCreateRole}>{t('RolesAndPermission.createRole')}</button>
                                )}

                                {activeComponent === 'userManagement' && hasPermission(PERMISSIONS.CAN_ONBOARD_ADMIN_USER) && (
                                    <button onClick={handleCreateUser}>{t('userManagement.createUser')}</button>
                                )}
                                {activeComponent === 'areaExecutive' && hasPermission(PERMISSIONS.CAN_CREATE_AREA_EXECUTIVE) && (
                                    <button onClick={handleAddAreaExecutive}>{t('areaExecutive.addAreaExecutive')}</button>
                                )}
                            </div>
                        </div>

                        <div className="content-section">
                            {activeComponent === 'roles' && <RolesAndPermission 
                            roles={roles} 
                            isLoading={isLoading} 
                            onRolesUpdate={(updatedRoles) => setRoles(updatedRoles)} />}
                            {activeComponent === 'userManagement' && <UserManagement roles={roles} />}
                            {activeComponent === 'areaExecutive' && <AreaExecutive roles={roles} />}
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default RolesAndUser